import AdminLayout from "@/components/AdminLayout";
import FileManager from "@/components/FileManager";

export default function Gallery() {
  return (
    <AdminLayout title="GALLERY">
      <FileManager
        section="gallery"
        allowedExtensions={[".png", ".jpg", ".jpeg", ".gif", ".mp4", ".webm", ".webp"]}
        canCreateText={false}
      />
    </AdminLayout>
  );
}
